module.exports = __webpack_public_path__ + "static/img/BG.66afeba8.svg";